<template>
  <div>
    <div class="columns columns-label" v-if="columns.length">
      <span v-for="(item,index) in columns" :key="index" :style="{width: labelWidths[index]}">{{ item.label }}</span>
    </div>
    <div v-if="!tableValues || !tableValues.length" style="height: 3rem;line-height: 3rem;text-align: center;font-size: 14px;color: #828282;">暂无数据</div>
    <div class="columns" v-for="(item,index) in tableValues" :key="index">
      <span v-for="(item1,index1) in item" :key="index1" :style="{width: labelWidths[index1]}">
        <!-- {{tableData[index][columns[index1].prop]}} -->
        <GridColumn :type="columns[index1].type" v-model="tableData[index][columns[index1].prop]" :key="index1"/>
      </span>
    </div>
  </div>

</template>

<script>
import GridColumn from './GridColumn.vue'

export default {
  components: {
    GridColumn,
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
  computed: {
    tableValues() {
      let arr = []
      this.tableData.forEach((item) => {
        arr.push(this.settableData(item))
      })
      return arr
    },
    labelWidths() {
      let num = 0
      let count = this.columns.length
      let arr = []
      this.columns.forEach(item => {
        if(item.width) {
          num += item.width
          count--
        }
      })
      this.columns.forEach(item => {
        if(item.width) {
          arr.push(item.width + 'px')
        } else {
          arr.push(`calc(${100/count}% - ${num / count}px)`)
        }
      })
      return arr
    }
  },
  created() {},
  methods: {
    settableData(obj) {
      let arr = []
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          this.columns.forEach((el, index) => {
            if (el.prop === key) {
              arr[index] = obj[key]
            }
          })
        }
      }
      return arr
    },
  },
}
</script>
<style lang="less" scoped>
.columns {
  font-size: 14px;
  border-bottom: 1px solid #ededed;
  & > span:nth-child(1) {
    // color: red;
    text-align: left;
  }
  span {
    display: inline-block;
    line-height: 30px;
    text-align: center;
    text-overflow: ellipsis;
    text-wrap: nowrap;
    overflow: hidden;
  }
}
.columns-label {
  color: #a6a6a6;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Grid/index.vue